import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionThreeImagesVerticalBody,
    SectionThreeImagesVerticalDetails,
} from "types/api/blocks/sectionThreeImagesVertical";

function useSectionThreeImagesVerticalApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionThreeImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionThreeImagesVerticalDetails> => {
        return get<PathParamsWithId, undefined, SectionThreeImagesVerticalDetails>({
            url: "/blocks/section-three-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionThreeImagesVertical = React.useCallback((body: SectionThreeImagesVerticalBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionThreeImagesVerticalBody, null>({
            url: "/blocks/section-three-images-vertical",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionThreeImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-three-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionThreeImagesVertical,
        saveSectionThreeImagesVertical,
        deleteSectionThreeImagesVertical
    };
}

export default useSectionThreeImagesVerticalApi;